export interface UserRelationCheck {
    hasValidRelations: boolean;
    isAdmin: boolean;
    hasDistributorAccess: boolean;
    hasRetailerAccess: boolean;
    relationDetails: {
        distributorAccesses: any[];
        retailerAccesses: any[];
    };
}

export async function checkUserRelations(user: any): Promise<UserRelationCheck> {
    // Extraire la valeur du ref si c'est un ref Vue
    const actualUser = user?.value || user;

    if (!actualUser) {
        return {
            hasValidRelations: false,
            isAdmin: false,
            hasDistributorAccess: false,
            hasRetailerAccess: false,
            relationDetails: { distributorAccesses: [], retailerAccesses: [] }
        };
    }

    // Vérifier si c'est un admin
    const isAdmin = actualUser.role === 'f472c9f3-7c0d-44bd-a3c3-968be0bd2f87';

    // CALCULER LES RELATIONS MÊME POUR LES ADMINS
    const distributorAccesses = actualUser.dentsu_distributors_accesses?.filter((access: any) =>
        access && access.status === 'published'
    ) || [];

    const retailerAccesses = actualUser.dentsu_pos_accesses?.filter((access: any) =>
        access && access.status === 'published'
    ) || [];

    const distributorDirects = actualUser.dentsu_distributors?.filter((distributor: any) =>
        distributor && distributor.status === 'published'
    ) || [];

    console.log('Distributor accesses found:', distributorAccesses);
    console.log('Retailer accesses found:', retailerAccesses);
    console.log('Direct distributors found:', distributorDirects);

    const hasDistributorAccess = distributorAccesses.length > 0 || distributorDirects.length > 0;
    const hasRetailerAccess = retailerAccesses.length > 0;
    const hasValidRelations = hasDistributorAccess || hasRetailerAccess || isAdmin; // Admin a toujours des relations valides

    if (isAdmin) {
        console.log('User identifié comme admin - accès autorisé');
    }

    return {
        hasValidRelations,
        isAdmin,
        hasDistributorAccess, // ← Maintenant calculé même pour les admins
        hasRetailerAccess,
        relationDetails: {
            distributorAccesses: [...distributorAccesses, ...distributorDirects],
            retailerAccesses
        }
    };
}